export default "__VITE_ASSET__CEuB$uIR__"